// One timeline entry in the Agenda section (button + card). Presentational.
export const AgendaItem = ({ item, index, active, revealed, itemRef, buttonRef, onSelect, onKeyDown }) => (
  <li ref={itemRef} className={`cfa-agenda-item${revealed ? " is-revealed" : ""}`}>
    <button
      ref={buttonRef}
      className="cfa-agenda-button"
      type="button"
      data-testid={`agenda-item-${index}`}
      aria-current={active ? "step" : undefined}
      aria-expanded={active}
      onClick={onSelect}
      onKeyDown={onKeyDown}
    >
      <span className="cfa-step">{index + 1}</span>
      <span className="cfa-agenda-card">
        <time className="cfa-agenda-time" dateTime={item.datetime}>{item.time}</time>
        <span className="cfa-agenda-title">{item.title}</span>
        {item.speaker && (
          <span className="cfa-agenda-speaker" data-testid={`agenda-speaker-${index}`}>Speaker: {item.speaker}</span>
        )}
        {item.tag && (
          <span className="cfa-agenda-speaker" data-testid={`agenda-tag-${index}`}>{item.tag}</span>
        )}
        <span className="cfa-agenda-description">{item.description}</span>
        <span className="cfa-agenda-detail" data-testid={`agenda-detail-${index}`}>{item.detail}</span>
      </span>
      <span className="cfa-agenda-arrow" aria-hidden="true">&rarr;</span>
    </button>
  </li>
);
